import { defineStore } from 'pinia'
import { API_BASE_URL } from './config'
import { ref, watch } from 'vue'
import axios from 'axios';

export function createDataStore(config) {

    return defineStore(`dataStore-${config.name}`, () => {

        const dbname = 'trackdata';
        const vehicles = ref([]);
        const journeys = ref([]);
        const events = ref([]);

        const workingjourneys = ref({});
        const selectedVehicles = ref(new Set());

        const stopJourneyList = ref([]);

        const pideventcounts = ref([]);
        const pidevents = ref([])

        async function fetchVehicles() {
            try {
                const token = localStorage.getItem('jwtToken');
                let filter = {
                    dbname: dbname
                }

                const response = await axios.post(`${API_BASE_URL}/eventvehicles`, filter, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });

                response.data.sort()

                vehicles.value = response.data;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            }
        }

        async function fetchJourneys() {
            try {
                const token = localStorage.getItem('jwtToken');
                let newData = []
                for (let vref of selectedVehicles.value) {

                    let filter = {
                        dbname: dbname,
                        vref: vref
                    }

                    const response = await axios.post(`${API_BASE_URL}/vehiclejourneys`, filter, {
                        headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                    });

                    // push onto new
                    newData = newData.concat(response.data);
                }
                newData.sort((a, b) => { return a.time - b.time })
                journeys.value = newData;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            }
        }

        async function fetchJourneyEvents() {
            try {
                const token = localStorage.getItem('jwtToken');
                let newData = []
                for (let jref in workingjourneys.value) {

                    let filter = {
                        dbname: dbname,
                        jref: jref
                    }

                    let fullname = `${API_BASE_URL}/journeyevents`

                    const response = await axios.post(fullname, filter, {
                        headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                    });

                    // push onto new
                    newData = newData.concat(response.data);
                }
                newData.sort((a, b) => { return a.time - b.time })
                journeys.value = newData;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            }
        }


        async function retrieveJourneyLegs(guid) {
            try {
                const token = localStorage.getItem('jwtToken');

                let filter = {
                    dbname: dbname,
                    guid: guid
                }

                const response = await axios.post(`${API_BASE_URL}/journeylegroutes`, filter, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });

                // push onto new
                let newData = response.data;
                newData.sort((a, b) => { return a.time - b.time })
                return newData;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            }
        }

        async function journeyaveroutes(ref) {
            try {
                const token = localStorage.getItem('jwtToken');

                let filter = {
                    dbname: dbname,
                    ref: ref
                }

                const response = await axios.post(`${API_BASE_URL}/journeyaveroutes`, filter, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });

                return response.data;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            }
        }

        async function retrieveJourneyEvents(guid) {
            try {
                const token = localStorage.getItem('jwtToken');

                let filter = {
                    dbname: dbname,
                    guid: guid
                }

                const response = await axios.post(`${API_BASE_URL}/journeyevents`, filter, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });

                // push onto new
                let newData = response.data;
                newData.sort((a, b) => { return a.time - b.time })
                return newData;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            }
        }

        watch(selectedVehicles, () => {
            fetchJourneys()
        });

        function addJourneyToWorking(journey) {
            if (!workingjourneys.value[journey.guid]) {
                workingjourneys.value[journey.guid] = journey
            } else {
                console.log("Already in the working list")
            }
        }

        function removeJourneyFromWorking(journey) {
            console.log(`removeJourneyFromWorking ${journey.guid}`)
            delete workingjourneys.value[journey.guid]
        }

        async function fetchStopJourneys() {
            try {
                const token = localStorage.getItem('jwtToken');
                const response = await axios.get(`${API_BASE_URL}/stopjourneylist`, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });

                stopJourneyList.value = response.data;
                console.log(`stopJourneyList : ${JSON.stringify(stopJourneyList.value)}`)
            } catch (error) {
                console.error('Error fetching stop journeys:', error)
            }
        }


        async function fetchPidEventsDayCounts() {
            try {
                const token = localStorage.getItem('jwtToken');

                let filter = {
                    dbname: config.dbname
                }

                const response = await axios.post(`${API_BASE_URL}/piddaycount`, filter, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });

                pideventcounts.value = response.data;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            }
        }

        async function fetchPidEvents(uid, timestart, timeend) {
            try {
                const token = localStorage.getItem('jwtToken');

                let filter = {
                    dbname: config.dbname,
                    uid: uid,
                    timestart: timestart,
                    timeend: timeend
                }

                const response = await axios.post(`${API_BASE_URL}/pidevents`, filter, {
                    headers: { Authorization: `Bearer ${token}` }, // Send token with each request
                });

                pidevents.value = response.data;
            } catch (error) {
                console.error('Error fetching vehicles:', error)
            }
        }

        return {
            vehicles,
            journeys,
            events,
            fetchVehicles,
            selectedVehicles,
            workingjourneys,
            addJourneyToWorking,
            removeJourneyFromWorking,
            stopJourneyList,
            fetchStopJourneys,
            fetchJourneyEvents,
            fetchPidEventsDayCounts,
            pideventcounts,
            fetchPidEvents,
            retrieveJourneyEvents,
            retrieveJourneyLegs,
            journeyaveroutes
        };
    })();

}
